// DashboardExperiments.jsx

import ProtectedGrafanaFrame from "./components/ProtectedGrafanaFrame";

const DashboardExperimentMonitor = () => {
  const grafanaExperimentDashboardUrl =
    "/grafana/d/exp-summary/efabric-experiment-summary?orgId=1&var-nodename=$__all&var-user=$__all&var-pod=$__all&kiosk";

  return (
    <ProtectedGrafanaFrame
      src={grafanaExperimentDashboardUrl}
      title="Experiment Monitor Dashboard"
      sx={{
        height: `calc(100vh - ${60}px)`,
      }}
    />
  );
};

export default DashboardExperimentMonitor;
